import { merchantDashboardIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const reorderMerchantDashboards = {
  name: "reorderMerchantDashboards" as const,
  input: z.object({
    dashboardIds: z.array(merchantDashboardIdFormat.schema).min(1),
  }),
  output: z.object({}),
};
